import { Box, Typography } from '@mui/material';
import { HERO_TEXT_EYEBROW, HERO_TEXT_MUTED, HERO_WHITE } from '../designTokens';

interface PieceHeadingProps {
  eyebrow?: string;
  line1: string;
  line2?: string;
}

export function PieceHeading({ eyebrow, line1, line2 }: PieceHeadingProps) {
  return (
    <Box>
      {eyebrow && (
        <Typography
          component="p"
          sx={{
            // 0.71875rem (11.5px) — hero eyebrow sits below the standard 0.7rem floor
            // intentionally: it's decorative metadata on a non-interactive dark surface,
            // matching the prototype's 11px hero labels.
            fontSize: '0.71875rem',
            letterSpacing: '0.14em',
            textTransform: 'uppercase',
            color: HERO_TEXT_EYEBROW,
            mb: 1.25,
          }}
        >
          {eyebrow}
        </Typography>
      )}
      <Typography
        sx={{
          fontSize: '2.375rem',
          fontWeight: 500,
          lineHeight: 1.08,
          letterSpacing: '-0.03em',
          color: HERO_WHITE,
        }}
      >
        {line1}
        {line2 && (
          <>
            <br />
            <Box component="span" sx={{ color: HERO_TEXT_MUTED }}>
              {line2}
            </Box>
          </>
        )}
      </Typography>
    </Box>
  );
}
